import { ChevronRight, X03 } from "@alchemy/ui/icons/16";
import clsx from "clsx";

import { ViewAsPreservingLink } from "@features/common/ViewAsPreservingLink";

interface NotificationPanelLinkProps {
  to: string;
  children: React.ReactNode;
  onDelete?: () => void;
  onClick?: () => void;
}

const NotificationPanelLink = ({
  to,
  children,
  onDelete,
  onClick,
}: NotificationPanelLinkProps) => {
  return (
    <div className="group flex border-t border-grayscale-200 first:border-0">
      <ViewAsPreservingLink
        to={to}
        className={clsx(
          "peer flex flex-1 justify-between gap-2 px-3.5 py-3",
          "text-paragraph-200-medium text-grayscale-700 outline-none transition",
          "hover:bg-grayscale-50 focus-visible:bg-grayscale-50 active:bg-grayscale-100",
        )}
        onClick={() => {
          onClick?.();
          onDelete?.();
        }}
      >
        <span>{children}</span>

        <ChevronRight className="mt-0.5 flex-shrink-0" />
      </ViewAsPreservingLink>

      {onDelete ? (
        <button
          className={clsx(
            "flex w-10 flex-shrink-0 items-center justify-center border-l border-inherit bg-grayscale-100 text-grayscale-700 outline-none transition-[margin_background-color]",
            "hover:bg-grayscale-200/70 focus-visible:bg-grayscale-200/70 active:bg-grayscale-100/60",
            "-mr-10 focus-visible:mr-0 focus-visible:transition-none group-hover:mr-0 peer-focus-visible:mr-0",
          )}
          aria-label="Delete"
          onClick={onDelete}
        >
          <X03 />
        </button>
      ) : null}
    </div>
  );
};

export default NotificationPanelLink;
